import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const ErrorPanel = styled.div`
    margin: auto;
    width: 100px;
`
export const SummaryStyle = styled.div`
    ${() => useFont('c32', { weight: '800' })};
    width: 450px;
    height: 50px;
    margin: auto;
`
export const DetailsStyle = styled.div`
    ${() => useFont('c16', { weight: '400' })};
    width: 650px;
    height: 30px;
    margin: auto;
`
